module.exports = __webpack_public_path__ + "img/mobile_t18.5c7eb9e5.png";